<template>
    <section class="about-header section-bg-3">
        <div class="container">
            <h1>{{ pageTitle }}</h1>
        </div>
    </section>

    <section class="container mt-25 pt-40">
        <div class="tabs-container">
            <ul class="tabs">
                <li
                    v-for="tab in tabs"
                    :key="tab.id"
                    :class="{ active: tab.id === activeTab }"
                    @click="activeTab = tab.id"
                >
                    {{ tab.name }}
                </li>
            </ul>

            <div class="tab-content" :lang="currentLanguage" :dir="currentLanguage === 'ar' ? 'rtl' : 'ltr'">
                <article
                    v-for="policy in policies"
                    v-show="activeTab === policy.id"
                    :key="policy.id"
                    class="policy-content"
                >
                    <header class="policy-header">
                        <h2>{{ policy.title[currentLanguage] }}</h2>
                        <p class="brand">Planning Force</p>
                        <p class="effective-date">{{ policy.date[currentLanguage] }}</p>
                    </header>

                    <div v-html="policy.content[currentLanguage]"></div>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "TermsTabs",

    data() {
        return {
            activeTab: "terms-of-use",
            policies: [
                {
                    id: "terms-of-use",
                    title: {
                        ar: "شروط وأحكام الاستخدام",
                        en: "Terms of Use",
                    },
                    date: {
                        ar: "1 أكتوبر 2025",
                        en: "October 11, 2025",
                    },
                    content: {
                        ar: `
                            <h3>1. النطاق والموافقة</h3>
                            <p>تنظم هذه الشروط استخدام منصة Planning Force وخدماتها، بما فيها الدورات المسجلة والمباشرة والباقات والاختبارات والمواد والشهادات. يعني إنشاء الحساب أو إتمام الشراء قبول الشروط المعروضة، وفق متطلبات الموافقة القانونية.</p>

                            <h3>2. الحساب والأهلية</h3>
                            <p>يلتزم المستخدم بتقديم بيانات صحيحة والحفاظ على سرية حسابه. الحساب شخصي ولا يجوز نقله أو مشاركته. ويجب الإبلاغ عن أي اختراق مشتبه به. يخضع استخدام القاصرين لموافقة ولي الأمر حيث يتطلب القانون ذلك.</p>

                            <h3>3. المنتجات والدفع</h3>
                            <p>تحدد صفحة كل منتج وصف الخدمة وسعرها وعملتها ومدة الوصول وشروطها الخاصة قبل الشراء. يثبت الطلب بعد نجاح الدفع. تخضع الضرائب والعروض والقسائم للشروط المعلنة والمتطلبات القانونية.</p>

                            <h3>4. مدة الوصول</h3>
                            <p>تختلف مدة إتاحة الدورة أو الباقة بحسب المدة المكتوبة في وصف المنتج وقت الشراء؛ ولا توجد مدة موحدة لكل الدورات. يبدأ احتساب المدة من التفعيل أو الإتاحة وفق ما يُعرض قبل الشراء. عدم مشاهدة المحتوى لا يمدد الصلاحية تلقائيًا، وأي تمديد مدفوع يخضع لشروط معلنة.</p>

                            <h3>5. الدورات المسجلة والاسترداد</h3>
                            <p>يمكن طلب استرداد قيمة الدورة المسجلة خلال سبعة (7) أيام تقويمية من تاريخ الشراء، بشرط عدم بدء مشاهدة أي جزء من محتواها. يبدأ احتساب المهلة من الشراء وليس التفعيل. لا يمس ذلك حقوق المستهلك الإلزامية عند عدم تقديم الخدمة أو عدم مطابقتها.</p>

                            <h3>6. الدورات المباشرة والإلغاء</h3>
                            <p>يمكن طلب إلغاء الدورة المباشرة واسترداد قيمتها قبل بدء أول جلسة في الموعد المعلن. بعد بدء الدورة لا يتوفر الاسترداد الاختياري العادي. إذا ألغت المنصة الدورة، يحق للمتدرب رد المبلغ المستحق أو قبول بديل بموافقته؛ وتنطبق الحقوق القانونية في حالات التغيير الجوهري أو الإخلال.</p>

                            <h3>7. الاختبارات والشهادات</h3>
                            <p>الاختبارات للتدريب ولا تضمن النجاح الرسمي. تحدد صفحة المنتج عدد المحاولات ومدة الوصول. تصدر شهادات الإتمام بحسب المتطلبات المعلنة، ولا تعني اعتمادًا مهنيًا خارجيًا ما لم يذكر ذلك صراحة.</p>

                            <h3>8. الملكية الفكرية</h3>
                            <p>يحتفظ أصحاب الحقوق بملكية المحتوى والعلامات التجارية والفيديوهات والملفات. يمنح الشراء ترخيصًا شخصيًا محدود المدة للاستخدام التعليمي، ولا يسمح بنسخ المحتوى أو تسجيله أو مشاركته أو إعادة بيعه. يجوز تنزيل الملفات التي توفرها المنصة صراحةً للاستخدام المسموح.</p>

                            <h3>9. السلوك المحظور والإنهاء</h3>
                            <p>يمنع مشاركة الحساب، والتحايل على الدفع أو أنظمة الحماية، واستخراج المحتوى آليًا بلا إذن، وانتحال الهوية، والإضرار بالمستخدمين. يجوز تعليق الحساب عند الخطر الأمني أو المخالفات الجسيمة بعد التحقق المناسب، مع إمكان الاعتراض ودون إسقاط الحقوق المالية الإلزامية.</p>

                            <h3>10. توافر الخدمة والمسؤولية</h3>
                            <p>قد تتوقف الخدمة مؤقتًا للصيانة أو أعطال مقدمي الخدمات. تعمل المنصة على المعالجة المناسبة إذا تعذر تقديم خدمة مدفوعة. لا تضمن النتائج الوظيفية أو اجتياز اختبارات الجهات الخارجية، ولا تستبعد مسؤولية لا يسمح القانون باستبعادها.</p>

                            <h3>11. الخصوصية والسياسات المرتبطة</h3>
                            <p>تسري سياسة الخصوصية على معالجة بيانات المستخدمين، وتسري سياسة الاسترداد المنفصلة على إجراءات الإلغاء ورد الأموال؛ وتُقرأ السياسات معًا دون الإخلال بالحقوق القانونية.</p>

                            <h3>12. التعديلات والشكاوى</h3>
                            <p>يجوز تحديث الشروط مع إعلان تاريخ السريان وإخطار المستخدمين بالتعديلات الجوهرية عند الاقتضاء. لا تلغي التعديلات حقوق المشتريات السابقة خلافًا للقانون. تُقدم الشكاوى عبر قنوات التواصل المعتمدة، مع بقاء حق اللجوء للجهات المختصة.</p>

                            <h3>13. بيانات الجهة المشغلة والتواصل</h3>
                            <p>قبل النشر يجب إضافة الاسم القانوني للجهة المشغلة، دولة التسجيل، عنوانها، البريد الرسمي المؤكد، والقانون الحاكم والجهة المختصة بعد المراجعة القانونية.</p>
                        `,
                        en: `
                            <h3>1. Scope and Acceptance</h3>
                            <p>These Terms govern the use of Planning Force and its recorded and live courses, bundles, practice tests, materials and certificates. Account registration or purchase signifies acceptance of the displayed terms, subject to applicable legal requirements.</p>

                            <h3>2. Accounts and Eligibility</h3>
                            <p>Users must provide accurate details, safeguard credentials, and promptly report suspected unauthorized access. Accounts are personal, non-transferable and may not be shared. Minors require parental authorization where the law requires it.</p>

                            <h3>3. Products and Payments</h3>
                            <p>Each product page specifies its description, price, currency, access period and special terms before checkout. Orders are confirmed following successful payment. Taxes, promotions and coupons follow the disclosed conditions and applicable laws.</p>

                            <h3>4. Course Access Period</h3>
                            <p>Access duration is the period stated on each course or bundle product page at purchase; no uniform duration applies. The period starts upon activation or availability as disclosed before purchase. Not viewing content does not automatically extend access. Paid extensions, if offered, have separately disclosed conditions.</p>

                            <h3>5. Recorded Courses and Refunds</h3>
                            <p>A voluntary refund for a recorded course may be requested within seven (7) calendar days of purchase only if the learner has not started watching any part of its content. The period runs from purchase, not activation. Mandatory consumer remedies for non-delivery or nonconformity remain unaffected.</p>

                            <h3>6. Live Courses and Cancellations</h3>
                            <p>A live course may be canceled for a refund before its first scheduled session begins. Ordinary voluntary refunds are unavailable after the course starts. If Planning Force cancels the course, learners are entitled to the applicable refund or may voluntarily accept an alternative; statutory rights continue to apply to material changes or non-performance.</p>

                            <h3>7. Practice Tests and Certificates</h3>
                            <p>Practice exams are training tools and do not guarantee official exam success. Attempt limits and access periods are disclosed per product. Completion certificates follow disclosed requirements and are not external professional accreditations unless expressly stated.</p>

                            <h3>8. Intellectual Property</h3>
                            <p>Course materials, brands, videos and files remain the property of their respective rights holders. Purchase grants a time-limited personal educational license, not permission to copy, record, share or resell. Explicitly downloadable resources may be used within their stated license.</p>

                            <h3>9. Prohibited Conduct and Termination</h3>
                            <p>Account sharing, payment or security circumvention, unauthorized scraping, impersonation and harm to others are prohibited. Accounts may be suspended for security risks or substantiated serious breaches, subject to appropriate review and appeal; statutory financial rights are preserved.</p>

                            <h3>10. Availability and Liability</h3>
                            <p>Services may be temporarily unavailable for maintenance or third-party outages. Appropriate remedies apply for failure to deliver a paid service. Employment outcomes and external examination success are not guaranteed; non-excludable legal liability remains intact.</p>

                            <h3>11. Privacy and Related Policies</h3>
                            <p>The Privacy Policy governs personal-data handling and the separate Refund Policy governs cancellations and reimbursements; these documents operate together without limiting mandatory legal rights.</p>

                            <h3>12. Changes and Complaints</h3>
                            <p>Terms may be updated with an effective date and appropriate notice of material changes. Updates do not unlawfully remove rights attached to prior purchases. Complaints may be submitted through published support channels without restricting access to competent authorities.</p>

                            <h3>13. Operator Identity and Contact</h3>
                            <p>Before publication, insert the operator's verified legal name, jurisdiction of registration, address, confirmed support email, and legally reviewed governing-law and dispute-resolution details.</p>
                        `,
                    },
                },
                {
                    id: "privacy-policy",
                    title: {
                        ar: "سياسة الخصوصية",
                        en: "Privacy Policy",
                    },
                    date: {
                        ar: "11 أكتوبر 2025",
                        en: "October 1, 2025",
                    },
                    content: {
                        ar: `
                            <h3>1. المقدمة والجهة المسؤولة</h3>
                            <p>تشرح هذه السياسة كيفية معالجة Planning Force لبيانات الزوار والمتدربين والمدربين. يجب إدراج الاسم القانوني وبيانات اتصال الجهة المسؤولة عن معالجة البيانات قبل النشر.</p>

                            <h3>2. البيانات المجمعة</h3>
                            <p>قد تتضمن البيانات: الاسم والبريد والهاتف وبيانات الحساب، والمشتريات والفواتير ومراجع الدفع، والدورات المسجلة ومدة صلاحيتها والتفعيل، والتقدم والاختبارات والشهادات، وطلبات الإلغاء والاسترداد، والتواصل مع الدعم، وعنوان IP وبيانات الأجهزة والاستخدام.</p>

                            <h3>3. مصادر البيانات</h3>
                            <p>نحصل على البيانات من المعلومات التي يقدمها المستخدم، ومن استخدام خدمات المنصة ومعاملات الشراء، ومن مزودي الخدمات المرتبطين بها عند الحاجة وبالحد المسموح قانونًا.</p>

                            <h3>4. أغراض المعالجة</h3>
                            <p>تُستخدم البيانات لإدارة الحساب، تفعيل الدورات وفق مدة المنتج، متابعة التعلم وإصدار الشهادات، معالجة المدفوعات والإلغاءات والاستردادات، دعم العملاء، الأمن ومنع الاحتيال، تحسين الخدمات والامتثال القانوني، والتسويق وفق الموافقات اللازمة.</p>

                            <h3>5. الأسس القانونية</h3>
                            <p>تشمل الأسس الملائمة تنفيذ العقد والالتزامات القانونية والموافقة عند اشتراطها والأسس الأخرى المسموح بها قانونًا. الموافقة على هذه السياسة ليست بديلًا عن موافقة تسويقية أو تتبع منفصلة عند لزومها.</p>

                            <h3>6. المشاركة مع الغير</h3>
                            <p>قد نشارك الحد الضروري من البيانات مع مزودي الاستضافة والدفع والبريد والتواصل والدورات المباشرة والتحليلات إذا كانت مستخدمة، ومع المدربين المخولين والجهات الرسمية عند الطلب القانوني الصحيح. لا تُباع البيانات الشخصية. يجب تأكيد أسماء أو فئات المزودين الفعليين قبل النشر.</p>

                            <h3>7. بيانات الدفع</h3>
                            <p>تعالج معاملات الدفع من خلال مقدمي خدمات الدفع المعتمدين. لا يُطلب من المتدرب إرسال أرقام البطاقات الكاملة أو رمز الحماية إلى الدعم. تحفظ المنصة مراجع الدفع والسجلات اللازمة للمحاسبة والاسترداد وفق القانون.</p>

                            <h3>8. الأمن</h3>
                            <p>تُتخذ ضوابط ملائمة مثل التشفير أثناء النقل وحماية كلمات المرور وتقييد الصلاحيات والمراقبة والنسخ الاحتياطي والاستجابة للحوادث، وفقًا لما هو منفذ فعلًا. لا يمكن ضمان خلو أي خدمة إلكترونية من المخاطر تمامًا.</p>

                            <h3>9. ملفات تعريف الارتباط</h3>
                            <p>قد تستخدم المنصة ملفات ضرورية للمصادقة وتشغيل الموقع، وأخرى للتفضيلات أو التحليل أو الإعلان إن كانت مفعلة. يُتاح التحكم بالموافقة على الملفات غير الضرورية متى فرض القانون ذلك. يجب توثيق أدوات التتبع المستخدمة فعليًا.</p>

                            <h3>10. الإشعارات والتسويق</h3>
                            <p>قد تُرسل إشعارات الطلبات وتفعيل الدورات ومواعيد البث ونتائج الاسترداد والأمان باعتبارها تشغيلية. أما الرسائل الترويجية فتخضع للأساس القانوني اللازم، مع آلية لإلغاء الاشتراك.</p>

                            <h3>11. الاحتفاظ والحذف</h3>
                            <p>يقتصر الاحتفاظ على المدة الضرورية للغرض أو الالتزام القانوني، بما في ذلك سجلات المشتريات والشهادات والاستردادات والأمن. عند انقضاء المدة تُحذف البيانات أو تُزال هويتها. يجب تحديد جدول مدد الاحتفاظ الفعلية قبل النشر.</p>

                            <h3>12. حقوق المستخدم</h3>
                            <p>بحسب القانون المعمول به، قد يحق للمستخدم الوصول إلى بياناته وتصحيحها وحذفها أو الاعتراض على معالجتها وسحب الموافقة وتقديم شكوى. قد يلزم إثبات الهوية وتوجد استثناءات قانونية لبعض طلبات الحذف.</p>

                            <h3>13. حذف الحساب</h3>
                            <p>يمكن طلب حذف الحساب عبر الدعم. ويُوضح قبل التنفيذ أثره على الدورات النشطة والشهادات والمشتريات، مع استمرار الاحتفاظ بالسجلات المطلوبة قانونًا.</p>

                            <h3>14. النقل خارج الدولة والقاصرين</h3>
                            <p>إذا تمت معالجة بيانات خارج دولة المستخدم تطبق الضمانات القانونية المناسبة. وتطبق متطلبات موافقة ولي الأمر وحماية القاصرين عندما يُسمح لهم باستخدام الخدمات.</p>

                            <h3>15. التعديلات والتواصل</h3>
                            <p>تنشر التعديلات بتاريخ سريانها وتُطلب موافقة جديدة عندما يفرض القانون ذلك. تُضاف قبل النشر بيانات الجهة المشغلة والبريد الرسمي المؤكد وقناة طلبات الخصوصية.</p>
                        `,
                        en: `
                            <h3>1. Introduction and Data Controller</h3>
                            <p>This Policy explains how Planning Force processes visitor, learner and instructor information. The verified legal identity and contact details of the responsible data controller must be inserted before publication.</p>

                            <h3>2. Information We Collect</h3>
                            <p>Data may include names, email and phone details, account information, orders, invoices and payment references, enrolled courses and access periods, activation, progress, exams, certificates, cancellations and refunds, support communications, IP addresses and device or usage information.</p>

                            <h3>3. Sources of Information</h3>
                            <p>Information comes from user submissions, platform activity and transactions, and relevant service providers where needed and lawfully permitted.</p>

                            <h3>4. Purposes of Processing</h3>
                            <p>Data are processed for account management, course access for the stated product period, learning progress and certificates, payment, cancellations and refunds, customer support, security and fraud prevention, service improvement, legal compliance and marketing subject to required permissions.</p>

                            <h3>5. Legal Bases</h3>
                            <p>Relevant legal bases may include contract performance, legal obligations, consent where required and other permitted grounds. Acceptance of this policy does not replace separately required marketing or tracking consent.</p>

                            <h3>6. Sharing with Third Parties</h3>
                            <p>We may disclose necessary data to actual hosting, payment, email, communications, live-class or analytics providers, authorized instructors and competent authorities upon valid legal request. Personal data are not sold. Actual provider names or categories must be confirmed before publication.</p>

                            <h3>7. Payment Data</h3>
                            <p>Payments are processed through authorized payment providers. Learners should not send full card details or security codes to support. Payment references and necessary accounting or refund records are retained as legally required.</p>

                            <h3>8. Security</h3>
                            <p>Appropriate measures, such as encrypted transmission, password protection, access controls, monitoring, backups and incident response, are used to the extent actually implemented. No online service can guarantee absolute security.</p>

                            <h3>9. Cookies</h3>
                            <p>The platform may use essential authentication cookies and, if deployed, preference, analytics or advertising cookies. Nonessential cookie controls and consent are provided where legally required. Actual tracking tools must be documented.</p>

                            <h3>10. Notifications and Marketing</h3>
                            <p>Operational messages may cover orders, activation, live-class schedules, refund outcomes and security. Marketing communications follow applicable permission requirements and include an opt-out method.</p>

                            <h3>11. Retention and Deletion</h3>
                            <p>Data are kept only as necessary for the purpose or legal obligations, including purchase, certificate, refund and security records, then deleted or de-identified. An actual retention schedule must be established before publication.</p>

                            <h3>12. Your Rights</h3>
                            <p>Subject to applicable law, users may have rights to access, correct, delete or object to processing, withdraw consent and complain to authorities. Identity checks and statutory retention exceptions may apply.</p>

                            <h3>13. Account Deletion</h3>
                            <p>Account deletion may be requested through support. Its implications for active access, certificates and orders are explained, while records that must legally be retained remain safeguarded.</p>

                            <h3>14. International Transfers and Minors</h3>
                            <p>Where data are processed internationally, appropriate legal safeguards apply. Parental-consent and child-protection requirements apply whenever minors are permitted to use services.</p>

                            <h3>15. Changes and Contact</h3>
                            <p>Updates will state their effective date, and fresh consent will be requested when required. Verified operator identity, official email and privacy-request channel must be added before publication.</p>
                        `,
                    },
                },
                {
                    id: "refund-policy",
                    title: {
                        ar: "سياسة الإلغاء واسترداد الأموال",
                        en: "Refund and Cancellation Policy",
                    },
                    date: {
                        ar: "1 أكتوبر 2025",
                        en: "October 1, 2025",
                    },
                    content: {
                        ar: `
                            <h3>1. الغرض والنطاق</h3>
                            <p>تنظم هذه السياسة استرداد قيمة الدورات المسجلة وإلغاء الدورات المباشرة والباقات والاختبارات والتمديدات، مع المحافظة على حقوق المستهلك الإلزامية. تُطبق الشروط الخاصة المعلنة قبل الشراء إذا كانت مشروعة.</p>

                            <h3>2. الدورات المسجلة: سبعة أيام قبل المشاهدة</h3>
                            <p>يحق للمتدرب طلب استرداد كامل المبلغ المدفوع خلال سبعة (7) أيام تقويمية من تاريخ الشراء، بشرط ألا يكون قد بدأ مشاهدة أي جزء من محتوى الدورة المسجلة. لا يبدأ احتساب المدة من تاريخ التفعيل. ويعتبر بدء تشغيل أي فيديو تعليمي أو درس مسجل بداية للمشاهدة لأغراض ضمان الاسترداد الاختياري. يجب إظهار هذا الشرط بوضوح قبل الدفع. ولا يلغي بدء المشاهدة حقوق الاسترداد القانونية عند عدم تقديم الخدمة أو عدم مطابقتها.</p>

                            <h3>3. الدورات المباشرة: قبل البداية</h3>
                            <p>يحق للمتدرب إلغاء التسجيل واسترداد كامل الرسوم المدفوعة إذا وصل طلب الإلغاء إلى القنوات الرسمية قبل الموعد المعلن لبدء أول جلسة. بعد بدء الجلسة الأولى، لا يتوفر الاسترداد الاختياري العادي، مع استمرار الحقوق القانونية في حالات الإلغاء من جانب المنصة أو الإخلال الجوهري.</p>

                            <h3>4. إلغاء المنصة أو التغيير الجوهري</h3>
                            <p>إذا ألغت Planning Force الدورة المباشرة قبل تقديمها، يتم رد كامل المبلغ المدفوع عن تلك الدورة، أو يُتاح موعد بديل لا يسري إلا بموافقة المتدرب. عند تغيير جوهري في الموعد أو الخدمة، يُتاح العلاج أو الاسترداد الذي يقرره القانون والاتفاق.</p>

                            <h3>5. الباقات</h3>
                            <p>تُراجع الباقات وفق شروطها المعلنة. قبل مشاهدة أي دورة مسجلة ضمن الباقة، يجوز طلب الاسترداد خلال 7 أيام من شراء الباقة وفق الضمان الاختياري، ما لم تتضمن الباقة خدمات مباشرة أو مكونات بشروط مستقلة مُعلنة. بعد بدء مشاهدة أحد مكوناتها يُراجع الاسترداد وفق شروط الباقة والحقوق القانونية. يجب توضيح طريقة احتساب الاسترداد الجزئي إن وُجد.</p>

                            <h3>6. الاختبارات والمواد الرقمية</h3>
                            <p>تُوضح صفحة الاختبار شروط التفعيل وعدد المحاولات. قبل بدء الاختبار أو فتح بنك الأسئلة قد يتاح الاسترداد حسب شروط المنتج. بعد استخدام الأسئلة قد يقيد الاسترداد الاختياري إذا أعلن القيد قانونيًا مسبقًا. تبقى حقوق معالجة الأعطال وعدم المطابقة.</p>

                            <h3>7. التمديدات وانتهاء الصلاحية</h3>
                            <p>تحدد مدة الوصول لكل دورة بحسب وصف المنتج عند الشراء. لا يستحق المتدرب ردًا لمجرد انتهاء مدة الوصول دون إكمال المحتوى. تخضع التمديدات المدفوعة لشروطها المنشورة وللحقوق القانونية.</p>

                            <h3>8. الأعطال وعدم تقديم الخدمة</h3>
                            <p>إذا تعذر تقديم المنتج المدفوع أو كان مختلفًا جوهريًا عن وصفه، تقدم المنصة إصلاحًا مناسبًا أو إعادة إتاحة أو تمديدًا أو استردادًا مستحقًا. لا يُفرض بديل على المستخدم عندما يمنحه القانون حق رد المبلغ.</p>

                            <h3>9. الشراء المكرر والعروض</h3>
                            <p>تراجع الخصومات المكررة ويُرد أي تحصيل مكرر مستحق. يُحسب الاسترداد على المبلغ المدفوع بالفعل بعد الخصم، ولا تتحول القسائم المجانية إلى مبالغ نقدية إلا إذا فرض القانون خلاف ذلك.</p>

                            <h3>10. طلب الاسترداد</h3>
                            <p>يُقدم الطلب عبر قناة الدعم الرسمية ويشمل اسم صاحب الحساب والبريد المسجل ورقم الطلب والدورة وتاريخ الشراء وسبب الطلب. لا تُرسل بيانات البطاقة المصرفية الكاملة أو رمز التحقق الأمني. يجب اعتماد قناة الدعم قبل نشر هذه السياسة.</p>

                            <h3>11. مواعيد الرد والتنفيذ</h3>
                            <p>المدة التشغيلية المقترحة للرد على الطلب المكتمل: خلال سبعة (7) أيام عمل. المدة التشغيلية المقترحة لتنفيذ المبلغ الموافق عليه: خلال خمسة عشر (15) يوم عمل، أو أسرع إن أوجب القانون. يتم الرد إلى وسيلة الدفع الأصلية ما أمكن، وقد تتأثر لحظة وصول المبلغ بإجراءات البنك.</p>

                            <h3>12. الاعتراض والتعديلات</h3>
                            <p>يحق للمستخدم الاعتراض على القرار عبر قناة الدعم، دون فقدان حقه في مراجعة الجهات المختصة. يُعلن أي تعديل لاحق بتاريخ سريانه ولا ينتقص بصورة غير قانونية من حقوق مشتريات سابقة.</p>

                            <h3>13. التواصل والاعتماد</h3>
                            <p>قبل النشر يلزم استكمال الاسم القانوني للشركة وعنوانها وبريد الدعم المؤكد والقانون الحاكم ومراجعة الإجراءات مع مزود الدفع والمستشار القانوني.</p>
                        `,
                        en: `
                            <h3>1. Purpose and Scope</h3>
                            <p>This Policy covers refunds for recorded courses and cancellations of live courses, bundles, practice tests and extensions, while preserving mandatory consumer rights. Lawful product-specific conditions disclosed before checkout also apply.</p>

                            <h3>2. Recorded Courses: Seven Days Before Viewing</h3>
                            <p>A learner may request a full voluntary refund within seven (7) calendar days of purchase provided they have not begun watching any portion of the recorded course. The period starts at purchase, not activation. Playing any instructional video or recorded lesson counts as the start of viewing for this voluntary guarantee. This condition must be prominent before payment. Starting to view does not remove statutory remedies for non-delivery or nonconformity.</p>

                            <h3>3. Live Courses: Before Start</h3>
                            <p>A learner may cancel and receive a full refund if the request reaches official support channels before the scheduled start of the first live session. Once that session begins, ordinary voluntary refunds are unavailable, without limiting statutory rights for provider cancellation or material non-performance.</p>

                            <h3>4. Provider Cancellation or Material Changes</h3>
                            <p>If Planning Force cancels a live course before delivery, the course fee is fully refunded, unless the learner voluntarily accepts an alternative date. Material schedule or service changes are remedied according to applicable law and the purchase agreement.</p>

                            <h3>5. Course Bundles</h3>
                            <p>Bundles follow their disclosed terms. Before viewing any recorded course within a bundle, a voluntary refund may be requested within seven days of buying the bundle, unless it includes live or separately governed components disclosed in advance. Once a component is viewed, applicable bundle rules and legal rights govern. Any partial-refund calculation must be explained.</p>

                            <h3>6. Tests and Digital Materials</h3>
                            <p>Test pages specify activation and attempt limits. Refunds may be available before attempting a test or accessing its question bank under product terms. Voluntary refunds after access may be restricted only where lawfully disclosed in advance; defect and nonconformity remedies remain.</p>

                            <h3>7. Extensions and Access Expiry</h3>
                            <p>Each product's stated access term governs. Failure to finish content before expiry does not by itself create a refund right. Paid extensions follow their disclosed terms and mandatory law.</p>

                            <h3>8. Technical Failures and Non-Delivery</h3>
                            <p>If a paid product is not delivered or materially differs from its description, the platform will provide an appropriate fix, renewed access, extension or refund. Alternatives cannot be forced where a refund is legally required.</p>

                            <h3>9. Duplicate Payments and Promotions</h3>
                            <p>Duplicate charges are reviewed and qualifying duplicate payments refunded. Refunds use the amount actually paid after discounts; free coupons are not cash redeemable unless the law requires otherwise.</p>

                            <h3>10. How to Request a Refund</h3>
                            <p>Requests must reach the official support channel and include the account name, registered email, order reference, product, purchase date and reason. Never send full payment card data or a card verification code. Confirm the official support channel before publication.</p>

                            <h3>11. Response and Refund Timelines</h3>
                            <p>Proposed operational response time for a complete request: within seven (7) business days. Proposed completion of an approved refund: within fifteen (15) business days, or sooner where legally required. Funds are returned to the original payment method where possible; bank processing may affect receipt time.</p>

                            <h3>12. Appeals and Changes</h3>
                            <p>Customers may appeal decisions through support without losing access to competent authorities. Any change will carry an effective date and cannot unlawfully diminish accrued rights from earlier purchases.</p>

                            <h3>13. Contact and Final Approval</h3>
                            <p>Before publication, complete the company's legal identity, address, confirmed support email and governing law, and review procedures with the payment provider and legal adviser.</p>
                        `,
                    },
                },
            ],
        };
    },

    computed: {
        ...mapGetters(["currentLanguage"]),

        pageTitle() {
            return this.currentLanguage === "ar"
                ? "الشروط والسياسات"
                : "Terms and Policies";
        },

        tabs() {
            return this.policies.map((policy) => ({
                id: policy.id,
                name: policy.title[this.currentLanguage] || policy.title.en,
            }));
        },
    },
};
</script>

<style lang="scss" scoped>
.tabs-container {
    display: flex;
    flex-direction: row;
    min-height: 50vh;
}

.tabs {
    list-style: none;
    margin: 0;
    padding: 0;
    border: 1px solid #d4eff8;
    display: flex;
    flex-direction: column;
    width: 350px;
    flex-shrink: 0;

    li {
        padding: 15px 20px;
        cursor: pointer;
        background-color: #f9f9f9;
        border-bottom: 1px solid #d4eff8;
        transition: background-color 0.3s ease;
        color: var(--Primary-600, #09445d);
        font-size: 16px;

        &:hover {
            background-color: #e4f6fd99;
        }

        &.active {
            background-color: #fff;
            font-weight: 600;
            border-inline-start: 3px solid #0e6f99;
        }
    }
}

.tab-content {
    padding: 25px 40px;
    flex-grow: 1;
    min-width: 0;
    background-color: #fff;
    border: 1px solid #d4eff8;
    overflow-wrap: anywhere;
}

.policy-header {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #d4eff8;

    h2 {
        color: var(--Primary-600, #09445d);
        font-size: 30px;
        font-weight: 700;
        line-height: 1.5;
        margin-bottom: 8px;
    }

    .brand {
        font-weight: 600;
        margin-bottom: 4px;
    }

    .effective-date {
        color: #777;
        font-size: 14px;
        margin: 0;
    }
}

.policy-content {
    color: var(--Neutral-600, #666);
    font-size: 16px;
    line-height: 1.9;

    :deep(h3) {
        color: var(--Primary-600, #09445d);
        font-size: 21px;
        font-weight: 700;
        line-height: 1.5;
        margin: 28px 0 12px;
    }

    :deep(p) {
        margin-bottom: 18px;
    }

    :deep(ul),
    :deep(ol) {
        padding-inline-start: 25px;
        margin-bottom: 18px;
    }
}

@media screen and (max-width: 768px) {
    .tabs-container {
        flex-direction: column;
    }

    .tabs {
        flex-direction: row;
        overflow-x: auto;
        width: 100%;
        margin-bottom: 20px;

        li {
            font-size: 14px;
            white-space: nowrap;
            padding: 12px 15px;
        }
    }

    .tab-content {
        padding: 20px 15px;
        border: none;
    }

    .policy-header h2 {
        font-size: 24px;
    }
}
</style>
